export default "__VITE_ASSET__DYBVafeB__"